import { connect } from 'react-redux';

import CustomWorkoutTeaser from 'components/views/PoolView/render/custom/CustomWorkout';
import { getSelectedExercisePreviewImage } from 'store/exercises';
import { RootStateType as ExercisesRotStateType } from 'store/exercises';
import { getCoach } from 'store/profile';
import { RootStateType as ProfileRootStateType } from 'store/profile';

type RootStateType = ProfileRootStateType & ExercisesRotStateType;

const mapStateToProps = (state: RootStateType, ownProps: any) => ({
	coach: getCoach(state),
	previewImage: getSelectedExercisePreviewImage(state, ownProps.id),
});

export default connect(mapStateToProps)(CustomWorkoutTeaser);
